// State argument is not application state, only the state this reducer is responsible for
function merchantInfo(state = null, action) {
    switch (action.type) {
      case "SET_MERCHANTINFO":
        return action.value;
      default:
        return state;
    }
  }
  export default merchantInfo;
  